import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../api/axios"; // استدعاء الـ api

export default function Footer() {
    const { t } = useTranslation();
    const [categories, setCategories] = useState([]);

    // جلب الأقسام دايناميك
    useEffect(() => {
        api.get("/categories")
            .then((res) => {
                const payload = res.data.data ?? res.data;
                setCategories(payload.data ?? payload);
            })
            .catch((err) => console.log(err));
    }, []);

    const currentYear = new Date().getFullYear(); // سنة دايناميك

    return (
        <footer className="text-center text-lg-start bg-dark text-light mt-auto">
            {/* قسم السوشيال ميديا */}
            <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom bg-primary text-white">
                <div className="me-5 d-none d-lg-block fw-bold">
                    <span>{t("footer_social")}</span>
                </div>
                <div>
                    <a href="https://facebook.com" target="_blank" rel="noreferrer" className="me-4 text-white text-decoration-none fs-5"><i className="bi bi-facebook"></i></a>
                    <a href="https://twitter.com" target="_blank" rel="noreferrer" className="me-4 text-white text-decoration-none fs-5"><i className="bi bi-twitter-x"></i></a>
                    <a href="https://instagram.com" target="_blank" rel="noreferrer" className="me-4 text-white text-decoration-none fs-5"><i className="bi bi-instagram"></i></a>
                    <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="me-4 text-white text-decoration-none fs-5"><i className="bi bi-linkedin"></i></a>
                </div>
            </section>

            {/* محتوى الفوتر */}
            <section className="py-4">
                <div className="container text-center text-md-start mt-5">
                    <div className="row mt-3">
                        {/* عمود 1: عن المتجر */}
                        <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                            <h6 className="text-uppercase fw-bold mb-4 text-primary">
                                <i className="bi bi-shop me-2"></i>{t("footer_about_title")}
                            </h6>
                            <p className="text-white-50 lh-lg small">
                                {t("footer_about_desc")}
                            </p>
                        </div>

                        {/* عمود 2: الأقسام (دايناميك) */}
                        <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                            <h6 className="text-uppercase fw-bold mb-4">{t("footer_cats_title")}</h6>
                            <p><Link to="/products" className="text-white-50 text-decoration-none small">{t("footer_cat_all")}</Link></p>
                            {categories.slice(0, 3).map((cat) => (
                                <p key={cat.id}>
                                    <Link to={`/products?category=${cat.id}`} className="text-white-50 text-decoration-none small">
                                        {cat.name}
                                    </Link>
                                </p>
                            ))}
                        </div>

                        {/* عمود 3: السياسات */}
                        <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                            <h6 className="text-uppercase fw-bold mb-4">{t("footer_policies_title")}</h6>
                            <p><Link to="/refund-policy" className="text-white-50 text-decoration-none small">{t("footer_pol_refund")}</Link></p>
                            <p><Link to="/terms" className="text-white-50 text-decoration-none small">{t("footer_pol_terms")}</Link></p>
                            <p><Link to="/privacy" className="text-white-50 text-decoration-none small">{t("footer_pol_privacy")}</Link></p>
                        </div>

                        {/* عمود 4: تواصل معنا */}
                        <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                            <h6 className="text-uppercase fw-bold mb-4">{t("footer_contact_title")}</h6>
                            <p className="text-white-50 small"><i className="bi bi-geo-alt-fill me-2"></i>{t("footer_contact_address")}</p>
                            <p className="text-white-50 small" dir="ltr"><i className="bi bi-telephone-fill me-2"></i>+20 100 000 0000</p>
                            <p className="text-white-50 small"><i className="bi bi-envelope-fill me-2"></i>info@wageh.store</p>
                            {/* رابط إضافي لصفحة تواصل معنا */}
                            <Link to="/contact" className="btn btn-outline-primary btn-sm mt-2 w-100">{t("footer_contact_title")}</Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* حقوق النشر (السنة دايناميك) */}
            <div className="text-center p-3 text-white-50" style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}>
                <small>Commerce App © {currentYear}. Built with React & Laravel API</small>
            </div>
        </footer>
    );
}